import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL || "https://api.articue.io";
const NLP_BASE_URL = "https://nlp.articue.io";

export default axios.create({
  baseURL: BASE_URL,
});

export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

export const axiosNLPPrivate = axios.create({
  baseURL: NLP_BASE_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});
